import { Outlet, NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, Clock, Users, BarChart3 } from "lucide-react";

const navItems = [
  { path: "/", icon: LayoutDashboard, label: "Dashboard" },
  { path: "/time-entry", icon: Clock, label: "Zeit" },
  { path: "/clients", icon: Users, label: "Kunden" },
  { path: "/reports", icon: BarChart3, label: "Berichte" },
];

export default function Layout() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[#09090B] pb-24">
      {/* Main Content */}
      <main className="max-w-lg mx-auto px-4 py-6">
        <Outlet />
      </main>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 glass z-50" data-testid="bottom-navigation">
        <div className="max-w-lg mx-auto px-4">
          <div className="flex items-center justify-around py-3">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path || 
                (item.path !== "/" && location.pathname.startsWith(item.path));
              const Icon = item.icon;
              
              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={`nav-item ${isActive ? "active" : ""}`}
                  data-testid={`nav-${item.label.toLowerCase()}`}
                >
                  <Icon size={22} strokeWidth={isActive ? 2 : 1.5} />
                  <span className="text-xs font-medium">{item.label}</span>
                </NavLink>
              );
            })}
          </div>
        </div>
      </nav>
    </div>
  );
}
